import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductImageConvertedInterface } from "../../common/interfaces/apiV2/shared/ProductImageInterface";

export type GalleryImageInput = {
    type: string;
    url: string;
    converted: Record<string, string> | ProductImageConvertedInterface;
};

export interface ProductGalleryModalSliceInterface {
    isActive: boolean;
    lightboxSlices: {
        src: string;
        width: number;
        height: number;
        type?: "video";
        poster?: string;
    }[];
    thumbnailLightBoxSettings: {
        width: number;
        height: number;
        border: number;
        borderRadius: number;
        padding: number;
        gap: number;
        showToggle: boolean;
        position: "start" | "end";
    };
}

const initialState: ProductGalleryModalSliceInterface = {
    isActive: false,
    lightboxSlices: [],
    thumbnailLightBoxSettings: {
        width: 90,
        height: 120,
        border: 1,
        borderRadius: 24,
        padding: 6,
        gap: 16,
        showToggle: false,
        position: "start",
    },
};

const productGalleryModalSlice = createSlice({
    name: "productGalleryModal",
    initialState,
    reducers: {
        setLightboxSlices: (
            state,
            action: PayloadAction<GalleryImageInput[]>,
        ) => {
            state.lightboxSlices = action.payload.map((image) => {
                const converted = image.converted as Record<string, string>;
                return {
                    src:
                        image.type === "video"
                            ? image.url
                            : (converted.HD ?? image.url),
                    width: 1080,
                    height: 1620,
                    type:
                        image.type === "video"
                            ? ("video-custom" as "video")
                            : undefined,
                    poster: image.type === "video" ? image.url : undefined,
                };
            });
        },
        setActive: (state, action) => {
            state.isActive = action.payload;
        },
    },
});

export const { setLightboxSlices, setActive } =
    productGalleryModalSlice.actions;

export const productGalleryModalReducer = productGalleryModalSlice.reducer;
